import React from "react";
import client from "@culturehq/client";
import { Badge, Icon, Panel, Tooltip } from "@culturehq/components";

import { useQueryString } from "app/context";
import { useFetch } from "app/hooks";
import { t, Trans } from "app/utils";

import ErrorBoundary from "components/common/ErrorBoundary";

const TrendingValue = ({ organizationValue }) => {
  const { onToggleQueryStringValue } = useQueryString();
  const onClick = () => onToggleQueryStringValue("v", organizationValue.id);

  return (
    <div className="SidePanel__row">
      <p>
        <Badge primary onClick={onClick}>
          <Icon icon="diamond" />
          {organizationValue.name}
        </Badge>
      </p>
    </div>
  );
};

const TrendingValues = () => {
  const { fetching, json } = useFetch(client.listRecognitionsOrganizationValues);
  const { organizationValues = [] } = json;

  return (
    <Panel className="SidePanel">
      <Panel.Heading>
        <Tooltip tip={t("The values that have been used in recognitions the most within the last 30 days.")}>
          <Icon icon="arrow-graph-up-right" />{" "}
          <Trans>Trending Values</Trans>
        </Tooltip>
      </Panel.Heading>
      <Panel.LoaderBody loading={fetching}>
        <ErrorBoundary>
          {organizationValues.map(organizationValue => (
            <TrendingValue
              key={organizationValue.id}
              organizationValue={organizationValue}
            />
          ))}
        </ErrorBoundary>
      </Panel.LoaderBody>
    </Panel>
  );
};

export default TrendingValues;
